import { styled } from "styled-components";

export const DefaultImageBase = styled.img<{ $isRounded?: boolean }>(
  ({ theme, $isRounded = true }) => {
    const rounded = {
      borderRadius: theme.radii[1],
    };

    return {
      width: 248,
      ...($isRounded ? rounded : {}),
    };
  },
);

export interface DefaultImageProps
  extends React.ComponentProps<typeof DefaultImageBase> {
  /** A URL for the image to render */
  image: string | null;

  /** If true, rounds the corners of the image border.
   *
   * @default true
   */
  isRounded?: boolean;
}

/** An image rendered as the `src` of an `<img>`. */
export const DefaultImage: React.FC<DefaultImageProps> = ({
  image,
  isRounded = true,
  ...props
}) => (
  <DefaultImageBase
    {...props}
    src={image || undefined}
    $isRounded={isRounded}
  />
);
